import { render } from "./WidthAndHeight.vue?vue&type=template&id=475ea146"
import script from "./WidthAndHeight.vue?vue&type=script&lang=ts"
export * from "./WidthAndHeight.vue?vue&type=script&lang=ts"
script.render = render

export default script